<script>
    import { onMount } from "svelte";
    import * as api from "../stores/memoMng.store";
    import { store } from "../stores/memoMng.store";
    import Menu from "../components/Menu.svelte";
    import Header from "../components/Header.svelte";
    import { push } from "svelte-spa-router";

    let pageSize = 100; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지

    onMount(() => {
        calculateWeekdays();
        getData();
    });

    async function getData() {
        // 모든 데이터를 한 번에 가져옴
        currentPage = 0;
        $store.currentList = [];

        const response = await api.apiGetMemoMng(
            $store.dvyfg_de,
            $store.keyword
        );
        $store.memoMngList = [];
        $store.memoMngList = response;

        loadMore(); // 초기 데이터 로드
    }

    function calculateWeekdays() {
        $store.weekdays = [];
        const today = new Date(); // 오늘 날짜 가져오기
        const todayDate = today.getDate(); // 오늘 날짜의 일자

        // 월~금 날짜 계산
        for (let i = 0; i < 5; i++) {
            const date = new Date($store.startOfWeek);
            date.setDate($store.startOfWeek.getDate() + i); // 월~금 날짜 계산
            $store.weekdays.push({
                day: ["월", "화", "수", "목", "금"][i],
                date: date.getDate(),
                fullDate: new Date(date), // 전체 날짜
            });
        }

        if ($store.firstLoad) {
            const todayWeekday = $store.weekdays.find(
                (day) => day.date === todayDate
            );
            if (todayWeekday) {
                $store.selectedDate = formatDate(today); // 오늘 날짜 선택
                $store.savedSelectedDate = $store.selectedDate; // savedSelectedDate에 저장
                $store.dvyfg_de = $store.selectedDate; // dvyfg_de 업데이트
            }
            $store.firstLoad = false;
        }

        // `selectedDate`가 현재 주에 포함되어 있으면 그대로, 없으면 null로 설정
        const selectedWeekday = $store.weekdays.find(
            (day) => formatDate(day.fullDate) === $store.selectedDate
        );

        if (!selectedWeekday) {
            $store.selectedDate = null; // 선택된 날짜가 없으면 null로 설정
        }
    }

    function day_next() {
        $store.startOfWeek.setDate($store.startOfWeek.getDate() + 7); // 7일 추가
        calculateWeekdays();

        // 주를 변경하고, `savedSelectedDate`가 있으면 그것을 복원
        if ($store.savedSelectedDate) {
            $store.selectedDate = $store.savedSelectedDate;
        } else {
            $store.selectedDate = null; // 저장된 날짜가 없으면 null
        }
    }

    function day_prev() {
        $store.startOfWeek.setDate($store.startOfWeek.getDate() - 7); // 7일 감소
        calculateWeekdays();

        // 주를 변경하고, `savedSelectedDate`가 있으면 그것을 복원
        if ($store.savedSelectedDate) {
            $store.selectedDate = $store.savedSelectedDate;
        } else {
            $store.selectedDate = null; // 저장된 날짜가 없으면 null
        }
    }

    // 날짜 포맷을 YYYYMMDD 형식으로 변환
    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}${month}${day}`;
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        // 추가 데이터를 currentList에 병합
        $store.currentList = [
            ...$store.currentList,
            ...$store.memoMngList.slice(start, end),
        ];
        $store.currentPage++;
    }

    // 스크롤 이벤트 핸들러
    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        // 스크롤이 끝에 도달하면 추가 데이터 로드
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if ($store.currentList.length < $store.memoMngList.length) {
                loadMore();
            }
        }
    }

    function goToDetail(no) {
        push(`/MemoMngDtl/${no}`);
    }

    function complete() {
        $store.selectedDate = null;
        $store.dvyfg_de = "complete";
        $store.savedSelectedDate = null;
        $store.isClicked = !$store.isClicked;

        getData();
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div>
    <Header title="스케줄" background_color="#a2474b" />

    <Menu />

    <div class="search-wrap search-wrap-double">
        <div class="search-wrapper">
            <div class="search-in">
                <input
                    type="text"
                    class="in-text"
                    bind:value={$store.keyword}
                    on:keydown={(e) => e.key === "Enter" && getData()}
                />
                <p class="search-btn" on:click={getData}>검색</p>
            </div>
        </div>
    </div>

    <div class="search-wrap">
        <div class="search-in">
            <div class="day-wrap">
                <div class="day-arrow">
                    <img
                        src="../resource/img/ico_left.png"
                        on:click={day_prev}
                    />
                </div>

                {#each $store.weekdays as { day, date, fullDate }}
                    <div
                        class="day-box {formatDate(fullDate) ===
                        $store.selectedDate
                            ? 'work-box-on'
                            : ''}"
                        on:click={() => {
                            $store.selectedDate = formatDate(fullDate); // 선택된 날짜를 YYYYMMDD 형식으로 설정
                            $store.savedSelectedDate = $store.selectedDate; // 선택된 날짜를 저장
                            $store.dvyfg_de = $store.selectedDate; // dvyfg_de 업데이트
                            $store.isClicked = false;
                            getData(); // 데이터 처리 함수 호출
                        }}
                    >
                        <p class="day">{day}</p>
                        <p class="date">{date}</p>
                    </div>

                    {#if date !== $store.weekdays[$store.weekdays.length - 1].date}
                        <div class="day-dot">
                            <img
                                src="../resource/img/ico_dot.png"
                                alt="구분점"
                            />
                        </div>
                    {/if}
                {/each}

                <div class="day-arrow">
                    <img
                        src="../resource/img/ico_right.png"
                        on:click={day_next}
                    />
                </div>
            </div>
            <p
                class="search-btn {$store.isClicked ? 'clicked' : ''}"
                on:click={complete}
            >
                완료
            </p>
        </div>
    </div>

    <div class="main scroll-custom" on:scroll={handleScroll}>
        {#if $store.currentList.length > 0}
            {#each $store.currentList as data, index}
                <div
                    class="main-in"
                    on:click={() => {
                        goToDetail(data.rcvord_no);
                    }}
                >
                    <!-- <p class="list-no">{index + 1}</p> -->
                    <p
                        class="list-title"
                        style="white-space: normal; color: {data.clos_at == 'Y'
                            ? 'rgb(255,0,8)'
                            : '#3D3D3D'}"
                    >
                        {data.contents}
                        <br />
                        ({data.contents_proc}-{data.qy}장)

                        {#if data.outord_rm != ""}
                            <br />
                            (외주_{data.outord_rm})
                        {/if}
                    </p>
                </div>
            {/each}
        {:else}
            <div class="main-in" style="place-content: center;">
                <p style="font-size: 17px;">검색된 결과가 없습니다.</p>
            </div>
        {/if}
    </div>
</div>
